import React from "react";
import { Routes, Route } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

import Header from "../Header/Header";
import SideBar from "../SideBar/SideBar";
import Footer from "../Footer/Footer";

import Dashboard from "../Dashboard/Dashboard";
import Computer from "../Computer/ComputerPage";
import Hardware from "../Hardware/HardwarePage";
import Software from "../Software/SoftwarePage";
import User from "../Users/UsersPage";
import Profile from "../Profile/ProfilePage";
import Issues from "../Issues/IssuesPage";
import Notification from "../Notifications/Alert";

import "./MainLayout.css";

const MainLayout = () => {
  return (
    <div className="app-layout">

      <Header />

      <div className="layout-body">

        <aside className="sidebar-wrapper d-none d-md-block">
          <SideBar />
        </aside>

        <main className="content-wrapper">

          <Container fluid>

            <Routes>

              <Route path="/dashboard" element={<Dashboard />} />

              <Route path="/computer" element={<Computer />} />

              <Route path="/profile" element={<Profile />} />

              <Route path="/user" element={<User />} />

              {/* <Route path="/software" element={<Software />} />

              <Route path="/hardware" element={<Hardware />} /> */}

              <Route path="/issues" element={<Issues />} />

              <Route path="/notification" element={<Notification />} />

            </Routes>

          </Container>

        </main>

      </div>

      <Footer />

    </div>
  );
};

export default MainLayout;